"use client";

import { useEffect, useState } from "react";
import type { HomepageAsset } from "@/lib/homepage";

/**
 * Fetches public site assets after mount so slow DB/storage never blocks first paint.
 * Returns null while loading, then the (possibly empty) asset list.
 */
export function useLazyAssets(categoriesKey: string): HomepageAsset[] | null {
  const [assets, setAssets] = useState<HomepageAsset[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`/api/assets?categories=${encodeURIComponent(categoriesKey)}`, { cache: "no-store" })
      .then((res) => (res.ok ? res.json() : { assets: [] }))
      .then((data) => {
        if (!cancelled) setAssets(Array.isArray(data.assets) ? data.assets : []);
      })
      .catch(() => {
        if (!cancelled) setAssets([]);
      });
    return () => {
      cancelled = true;
    };
  }, [categoriesKey]);

  return assets;
}

export function CarouselSkeleton({ frameClassName = "aspect-[4/3]" }: { frameClassName?: string }) {
  return (
    <div aria-hidden="true" className="grid grid-cols-1 gap-4 px-14 md:grid-cols-3">
      {[0, 1, 2].map((i) => (
        <div key={i} className={`${frameClassName} animate-pulse rounded-2xl bg-gray-100`} />
      ))}
    </div>
  );
}
